import React from "react";
import { capitalize } from "../../../helpers/capitalize";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const TransactionModal = ({
  id,
  transactionDetailsOpen,
  closeTransactionDetails,
  openViewReceipt,
  singleTransaction,
  logAudit,
}) => {
  const dateOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const handleDownloadReceipt = async () => {
    try {
      // Create a clone of the receipt template
      const element = document.getElementById("receipt-template");
      if (!element) return;

      // Clone the element and append it off-screen
      const clone = element.cloneNode(true);
      clone.style.position = "absolute";
      clone.style.left = "-9999px";
      clone.style.top = "0";
      clone.style.display = "flex"; // Ensure it's visible for html2canvas
      document.body.appendChild(clone);

      // Capture the clone
      const canvas = await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        logging: false,
      });

      // Convert to JPEG and generate PDF
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(
        `${singleTransaction?.sender_name || singleTransaction?.transactionId || singleTransaction?.membername}_receipt.pdf`,
      );
      logAudit({
        category: "Transactions",
        actionCode: "DOWNLOAD_TRANSACTION_RECEIPT",
        description: `Downloaded receipt for transaction (Transaction ID ${singleTransaction?.public_id})`,
        page: "Transactions",
        tab: "Transaction Details",
        section: "Receipt",
        transactionId: singleTransaction?.public_id,
        metadata: {
          route: "/dashboard/transactions",
        },
      });
      // Clean up the clone
      document.body.removeChild(clone);
    } catch (error) {
      logAudit({
        category: "Transactions",
        actionCode: "DOWNLOAD_TRANSACTION_RECEIPT_FAILED",
        description: `Failed to download receipt for transaction (Transaction ID ${singleTransaction?.public_id})`,
        page: "Transactions",
        tab: "Transaction Details",
        section: "Receipt",
        transactionId: singleTransaction?.public_id,
        metadata: {
          route: "/dashboard/transactions",
          error: error?.message || "Error downloading receipt",
        },
      });

      console.error("Error downloading receipt:", error);
    }
  };
  return (
    <>
      <div
        id={id}
        className={`${
          transactionDetailsOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow w-[40%] mx-auto rounded-lg">
            <div className="">
              <div
                onClick={closeTransactionDetails}
                className="absolute right-[0px] cursor-pointer w-[40px] h-[40px] top-[0px] flex items-center justify-center"
              >
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="1.06058"
                    y1="0.353478"
                    x2="18.3557"
                    y2="17.6486"
                    stroke="black"
                  />
                  <line
                    y1="-0.5"
                    x2="24.459"
                    y2="-0.5"
                    transform="matrix(-0.707107 0.707107 0.707107 0.707107 18.0024 0.707031)"
                    stroke="black"
                  />
                </svg>
              </div>
              <div className="flex-col flex justify-end mt-8 px-8 h-[8vh]">
                <p className="text-[#000000] text-[20px] font-[600]">
                  Transaction Details
                </p>
              </div>

              <div
                className="flex-col flex justify-center rounded-lg mt-5 px-5 w-[92%] mx-auto"
                style={{
                  border: "0.7px solid var(--Grey-for-non-actve, #E8E8E8)",
                }}
              >
                <div className="flex items-center justify-between py-3">
                  <div className="flex items-center gap-5">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="50"
                        height="50"
                        rx="25"
                        fill="url(#paint0_linear_17225_7135)"
                      />
                      <path
                        d="M25.5 16.1725V24.5001C25.5 24.6907 25.4243 24.8735 25.2895 25.0083C25.1547 25.1431 24.9719 25.2188 24.7812 25.2188C24.5906 25.2188 24.4078 25.1431 24.273 25.0083C24.1382 24.8735 24.0625 24.6907 24.0625 24.5001V16.1725L22.4148 17.8211C22.2799 17.956 22.097 18.0317 21.9062 18.0317C21.7155 18.0317 21.5326 17.956 21.3977 17.8211C21.2629 17.6862 21.1871 17.5033 21.1871 17.3126C21.1871 17.1218 21.2629 16.9389 21.3977 16.8041L24.2727 13.9291C24.3395 13.8622 24.4188 13.8092 24.506 13.773C24.5933 13.7369 24.6868 13.7183 24.7812 13.7183C24.8757 13.7183 24.9692 13.7369 25.0565 13.773C25.1437 13.8092 25.223 13.8622 25.2898 13.9291L28.1648 16.8041C28.2996 16.9389 28.3754 17.1218 28.3754 17.3126C28.3754 17.5033 28.2996 17.6862 28.1648 17.8211C28.0299 17.956 27.847 18.0317 27.6562 18.0317C27.4655 18.0317 27.2826 17.956 27.1477 17.8211L25.5 16.1725ZM31.25 24.1066V21.6251C31.25 21.2438 31.0985 20.8782 30.829 20.6086C30.5594 20.339 30.1937 20.1876 29.8125 20.1876H28.375C28.1844 20.1876 28.0016 20.2633 27.8668 20.3981C27.732 20.5329 27.6562 20.7157 27.6562 20.9063C27.6562 21.097 27.732 21.2798 27.8668 21.4146C28.0016 21.5494 28.1844 21.6251 28.375 21.6251H29.8125V28.8485C29.3839 28.4106 28.8102 28.1443 28.1991 28.0994C27.588 28.0545 26.9815 28.2342 26.4935 28.6048C26.0055 28.9753 25.6695 29.5112 25.5487 30.1119C25.4278 30.7126 25.5303 31.3368 25.8369 31.8673L25.8585 31.9014L27.8584 34.9561C27.9628 35.1156 28.1262 35.2272 28.3128 35.2662C28.4994 35.3052 28.6939 35.2684 28.8534 35.1641C29.0129 35.0597 29.1245 34.8962 29.1635 34.7096C29.2025 34.523 29.1658 34.3286 29.0614 34.1691L27.0732 31.1332C26.9322 30.8844 26.8959 30.5897 26.9722 30.314C27.0486 30.0384 27.2313 29.8043 27.4802 29.6634C27.729 29.5225 28.0237 29.4862 28.2994 29.5625C28.575 29.6388 28.8091 29.8215 28.95 30.0704C28.9563 30.0821 28.9635 30.0937 28.9707 30.1045L29.9302 31.5699C30.015 31.6992 30.1393 31.7978 30.2846 31.8509C30.4299 31.9039 30.5884 31.9087 30.7366 31.8645C30.8848 31.8203 31.0149 31.7295 31.1074 31.6055C31.1998 31.4816 31.2499 31.331 31.25 31.1764V25.9376C31.9275 26.5647 32.4685 27.3246 32.8395 28.1699C33.2105 29.0153 33.4034 29.928 33.4062 30.8511V34.5626C33.4062 34.7532 33.482 34.936 33.6168 35.0708C33.7516 35.2056 33.9344 35.2813 34.125 35.2813C34.3156 35.2813 34.4984 35.2056 34.6332 35.0708C34.768 34.936 34.8438 34.7532 34.8438 34.5626V30.8475C34.8397 29.5161 34.5101 28.2058 33.8837 27.0309C33.2574 25.856 32.3532 24.852 31.25 24.1066ZM21.1875 20.1876H19.75C19.3688 20.1876 19.0031 20.339 18.7335 20.6086C18.464 20.8782 18.3125 21.2438 18.3125 21.6251V30.9688C18.3125 31.1595 18.3882 31.3423 18.523 31.4771C18.6578 31.6119 18.8406 31.6876 19.0312 31.6876C19.2219 31.6876 19.4047 31.6119 19.5395 31.4771C19.6743 31.3423 19.75 31.1595 19.75 30.9688V21.6251H21.1875C21.3781 21.6251 21.5609 21.5494 21.6957 21.4146C21.8305 21.2798 21.9062 21.097 21.9062 20.9063C21.9062 20.7157 21.8305 20.5329 21.6957 20.3981C21.5609 20.2633 21.3781 20.1876 21.1875 20.1876Z"
                        fill="#029902"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_17225_7135"
                          x1="14.5"
                          y1="3.5"
                          x2="35"
                          y2="50"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#E6FFEF" />
                          <stop offset="1" stop-color="#ABEBC2" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div className="flex-col flex justify-center">
                      <p className="text-[#000000] text-[14px] font-normal">
                        Deposit to{" "}
                        {singleTransaction?.note ||
                          capitalize(singleTransaction?.type) ||
                          "Loans"}{" "}
                        Account
                      </p>
                      <p className="text-[#316CE9] text-[14px] font-normal">
                        {singleTransaction?.public_id ||
                          singleTransaction?.payment_code ||
                          singleTransaction?.memberid}
                      </p>
                    </div>
                  </div>
                  <div className="flex text-[#000000] text-[20px] font-[600]">
                    KES{" "}
                    {Number(
                      singleTransaction?.amount ??
                        singleTransaction?.payment_amount ??
                        singleTransaction?.balance ??
                        "0.00",
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>

              <div className="flex-col flex items-center justify-center mx-auto w-[92%] mt-8">
                <div className="flex w-[99%] items-center justify-between">
                  <p className="text-[#000000] font-normal text-[14px]">
                    Transaction ID
                  </p>
                  <p className="text-[#000000] text-[15px] font-[600]">
                    {singleTransaction?.ref_number ||
                      singleTransaction?.payment_code ||
                      singleTransaction?.transactionId ||
                      singleTransaction?.transactionid}
                  </p>
                </div>
                <div className="flex w-[99%] items-center justify-between mt-5">
                  <p className="text-[#000000]  font-normal text-[14px]">
                    Transaction Status
                  </p>
                  <div className="flex items-center bg-[#E6FFEF] gap-2 px-1">
                    <span>
                      {singleTransaction?.status?.toLowerCase() ===
                        "completed" && (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 0C8.73438 0 9.44271 0.09375 10.125 0.28125C10.8073 0.46875 11.4427 0.739583 12.0312 1.09375C12.6198 1.44792 13.1589 1.86458 13.6484 2.34375C14.138 2.82292 14.5573 3.36198 14.9062 3.96094C15.2552 4.5599 15.5234 5.19792 15.7109 5.875C15.8984 6.55208 15.9948 7.26042 16 8C16 8.73438 15.9062 9.44271 15.7188 10.125C15.5312 10.8073 15.2604 11.4427 14.9062 12.0312C14.5521 12.6198 14.1354 13.1589 13.6562 13.6484C13.1771 14.138 12.638 14.5573 12.0391 14.9062C11.4401 15.2552 10.8021 15.5234 10.125 15.7109C9.44792 15.8984 8.73958 15.9948 8 16C7.26562 16 6.55729 15.9062 5.875 15.7188C5.19271 15.5312 4.55729 15.2604 3.96875 14.9062C3.38021 14.5521 2.84115 14.1354 2.35156 13.6562C1.86198 13.1771 1.44271 12.638 1.09375 12.0391C0.744792 11.4401 0.476562 10.8021 0.289062 10.125C0.101562 9.44792 0.00520833 8.73958 0 8C0 7.26562 0.09375 6.55729 0.28125 5.875C0.46875 5.19271 0.739583 4.55729 1.09375 3.96875C1.44792 3.38021 1.86458 2.84115 2.34375 2.35156C2.82292 1.86198 3.36198 1.44271 3.96094 1.09375C4.5599 0.744792 5.19792 0.476562 5.875 0.289062C6.55208 0.101562 7.26042 0.00520833 8 0ZM12.7109 5.35156L11.6484 4.28906L6.5 9.4375L4.35156 7.28906L3.28906 8.35156L6.5 11.5625L12.7109 5.35156Z"
                            fill="#0C722F"
                          />
                        </svg>
                      )}
                      {singleTransaction?.status?.toLowerCase() ===
                        "pending" && (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.75 8.625C4.0625 8.625 4.32825 8.5155 4.54725 8.2965C4.76625 8.0775 4.8755 7.812 4.875 7.5C4.875 7.1875 4.7655 6.92175 4.5465 6.70275C4.3275 6.48375 4.062 6.3745 3.75 6.375C3.4375 6.375 3.17175 6.4845 2.95275 6.7035C2.73375 6.9225 2.6245 7.188 2.625 7.5C2.625 7.8125 2.7345 8.07825 2.9535 8.29725C3.1725 8.51625 3.438 8.6255 3.75 8.625ZM7.5 8.625C7.8125 8.625 8.07825 8.5155 8.29725 8.2965C8.51625 8.0775 8.6255 7.812 8.625 7.5C8.625 7.1875 8.5155 6.92175 8.2965 6.70275C8.0775 6.48375 7.812 6.3745 7.5 6.375C7.1875 6.375 6.92175 6.4845 6.70275 6.7035C6.48375 6.9225 6.3745 7.188 6.375 7.5C6.375 7.8125 6.4845 8.07825 6.7035 8.29725C6.9225 8.51625 7.188 8.6255 7.5 8.625ZM11.25 8.625C11.5625 8.625 11.8282 8.5155 12.0472 8.2965C12.2662 8.0775 12.3755 7.812 12.375 7.5C12.375 7.1875 12.2655 6.92175 12.0465 6.70275C11.8275 6.48375 11.562 6.3745 11.25 6.375C10.9375 6.375 10.6717 6.4845 10.4527 6.7035C10.2337 6.9225 10.1245 7.188 10.125 7.5C10.125 7.8125 10.2345 8.07825 10.4535 8.29725C10.6725 8.51625 10.938 8.6255 11.25 8.625ZM7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4807 2.19375 12.8062C1.51875 12.1312 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1312 1.51925 12.8062 2.19375C13.4812 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4807 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15Z"
                            fill="#FFCB35"
                          />
                        </svg>
                      )}
                      {singleTransaction?.status?.toLowerCase() ===
                        "incomplete" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="9"
                          viewBox="0 0 9 9"
                          fill="none"
                        >
                          <circle cx="4.5" cy="4.5" r="4.5" fill="#FAB32B" />
                        </svg>
                      )}
                    </span>
                    <p className="text-[#0C722F] text-[14px] font-normal px-1">
                      {capitalize(singleTransaction?.status) || "Completed"}
                    </p>
                  </div>
                </div>
                <div className="flex w-[99%] items-center justify-between mt-5">
                  <p className="text-[#000000]  font-normal text-[14px]">
                    Transaction Date
                  </p>
                  <p className="text-[#000000] text-[14px] font-[600]">
                    {(singleTransaction?.createdAt ||
                      singleTransaction?.payment_date ||
                      singleTransaction?.date ||
                      singleTransaction?.purchasedate) &&
                      new Intl.DateTimeFormat("en-US", dateOptions).format(
                        new Date(
                          (
                            singleTransaction?.createdAt ||
                            singleTransaction?.payment_date ||
                            singleTransaction?.date ||
                            singleTransaction?.purchasedate
                          )?.replace(" ", "T"),
                        ),
                      )}
                  </p>
                </div>
                <div className="flex w-[99%] items-center justify-between mt-5">
                  <p className="text-[#000000]  font-normal text-[14px]">
                    Amount
                  </p>
                  <p className="text-[#000000]  text-[14px] font-[600]">
                    <p className="text-[#000000] text-[14px] font-[600]">
                      KES{" "}
                      {Number(
                        singleTransaction?.amount ??
                          singleTransaction?.payment_amount ??
                          singleTransaction?.balance ??
                          "0.00",
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </p>
                  </p>
                </div>

                <div className="flex w-[99%] items-center justify-between mt-5">
                  <p className="text-[#000000] font-normal text-[14px]">
                    Transaction Type
                  </p>
                  <p className="text-[#000000] text-[15px] font-[600]">
                    {singleTransaction?.shareprice
                      ? "Share Purchase"
                      : capitalize(singleTransaction?.type) || "Loan Repayment"}
                  </p>
                </div>

                <div className="flex w-[99%] items-center justify-between mt-5">
                  <p className="text-[#000000] font-normal text-[14px]">
                    Payment Method
                  </p>
                  <p className="text-[#000000] text-[14px] font-[600]">
                    {singleTransaction?.deposit_method || "MPESA"}
                  </p>
                </div>

                {singleTransaction?.type?.toLowerCase() !== "membership" &&
                  Number(singleTransaction?.running_balance) > 0 && (
                    <div className="flex w-[99%] items-center justify-between mt-5">
                      <p className="text-[#000000] font-normal text-[14px]">
                        Member Balance After Transaction
                      </p>
                      <p className="text-[#000000] text-[14px] font-[600]">
                        KES{" "}
                        {Number(
                          singleTransaction?.running_balance,
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                  )}
                {(singleTransaction?.document_url ||
                  singleTransaction?.payment_document_url) && (
                  <div className="flex w-[99%] items-center justify-between mt-5">
                    <p className="text-[#000000] font-normal text-[14px]">
                      Receipt
                    </p>
                    <p
                      onClick={() =>
                        openViewReceipt(
                          singleTransaction?.document_url ||
                            singleTransaction?.payment_document_url,
                        )
                      }
                      className="text-[#037BD1] text-[14px] truncate cursor-pointer"
                    >
                      {(
                        singleTransaction?.document_url ||
                        singleTransaction?.payment_document_url
                      )
                        ?.split("/")
                        ?.pop()
                        ?.slice(-40)}
                    </p>
                  </div>
                )}
              </div>

              <div className="flex items-center justify-center mt-20 mx-auto mb-8 gap-5">
                <div
                  onClick={handleDownloadReceipt}
                  className="flex items-center justify-center bg-[#E8E8E8] gap-3 py-3 w-[44%] rounded-lg cursor-pointer"
                >
                  <svg
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.75 12.254V13.25C0.75 14.0456 1.06607 14.8087 1.62868 15.3713C2.19129 15.9339 2.95435 16.25 3.75 16.25H13.75C14.5456 16.25 15.3087 15.9339 15.8713 15.3713C16.4339 14.8087 16.75 14.0456 16.75 13.25V12.25M8.75 0.75V11.75M8.75 11.75L12.25 8.25M8.75 11.75L5.25 8.25"
                      stroke="#074073"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p className="text-[16px] font-[500]">Download Receipt</p>
                </div>
              </div>

              <div
                id="receipt-template"
                className="hidden w-full max-w-[550px] bg-white flex flex-col min-h-[110vh] mx-auto"
              >
                {/* Upper area */}
                <div className="bg-[#E8E8E8] w-full px-5 py-5 flex-shrink-0">
                  <div className="flex items-center justify-between mb-6">
                    <img src="/logo.png" alt="Logo" className="z-50" />
                    <div className="flex flex-col text-right">
                      {(() => {
                        const now = new Date();
                        const dateOptions = {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        };
                        const timeOptions = {
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        };
                        const currentDate = new Intl.DateTimeFormat(
                          "en-US",
                          dateOptions,
                        ).format(now);
                        const currentTime = new Intl.DateTimeFormat(
                          "en-US",
                          timeOptions,
                        ).format(now);
                        return (
                          <>
                            <p className="text-[7px] sm:text-[9px] text-[#000000] font-normal">
                              {currentDate}
                            </p>
                            <p className="text-[7px] sm:text-[9px] text-[#000000] font-normal mt-2">
                              {currentTime}
                            </p>
                          </>
                        );
                      })()}
                    </div>
                  </div>

                  <div className="flex justify-between items-start mb-3">
                    <div className="pr-4 max-w-[60%] flex flex-col justify-between">
                      <p className="text-[16px] sm:text-[18px] text-[#000000] font-[600] mb-2 break-words">
                        Your transaction is complete.
                      </p>
                      <p className="text-[16px] sm:text-[18px] text-[#000000] font-[600] mb-2 break-words">
                        Thanks for choosing us, <br />
                        {singleTransaction?.sender_name}.
                      </p>
                      <p className="text-[8px] sm:text-[10px] text-[#000000] break-words">
                        We hope this step brings you closer to your goals.
                      </p>
                    </div>
                    {/* <img
                      src="/receipt.png"
                      alt="Receipt"
                      className="object-contain h-[75px] sm:h-[100px] md:h-[120px]"
                    /> */}
                  </div>
                </div>

                {/* Transaction details - flex-grow to push footer down */}
                <div className="flex-grow flex flex-col items-center justify-start mx-auto w-[92%] mt-5 space-y-2 break-words">
                  {[
                    {
                      label: "Transaction ID",
                      value:
                        singleTransaction?.ref_number ||
                        singleTransaction?.payment_code ||
                        singleTransaction?.transactionId ||
                        singleTransaction?.transactionid,
                    },
                    {
                      label: "Transaction Type",
                      value: singleTransaction?.shareprice
                        ? "Share Purchase"
                        : capitalize(singleTransaction?.type) ||
                          "Loan Repayment",
                    },
                    {
                      label: "Status",
                      value: capitalize(singleTransaction?.status),
                      valueClass: "text-[#000000]",
                    },
                    {
                      label: "Date & Time",
                      value:
                        (singleTransaction?.createdAt ||
                          singleTransaction?.payment_date ||
                          singleTransaction?.date ||
                          singleTransaction?.purchasedate) &&
                        new Intl.DateTimeFormat("en-US", dateOptions).format(
                          new Date(
                            singleTransaction?.createdAt ||
                              singleTransaction?.payment_date ||
                              singleTransaction?.date ||
                              singleTransaction?.purchasedate,
                          ),
                        ),
                    },
                    ...(singleTransaction?.receiver_account_number
                      ? [
                          {
                            label: "Account NO",
                            value: singleTransaction?.receiver_account_number,
                          },
                        ]
                      : []),
                    {
                      label: "Amount",
                      value: `KES ${Number(
                        singleTransaction?.amount ||
                          singleTransaction?.payment_amount ||
                          singleTransaction?.balance ||
                          "0.00",
                      ).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`,
                      valueClass: "text-[#029902]",
                    },
                    {
                      label: "Payment Method",
                      value: singleTransaction?.deposit_method || "MPESA",
                    },
                  ]?.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex w-full justify-between text-[10px] sm:text-[12px]"
                    >
                      <p className="text-[#000000] font-normal">
                        {item?.label}:
                      </p>
                      <p className={`${item?.valueClass || ""} font-normal`}>
                        {item?.value}
                      </p>
                    </div>
                  ))}

                  {/* Optional Balance */}
                  {singleTransaction?.type?.toLowerCase() !== "membership" && (
                    <div className="flex w-full justify-between text-[10px] sm:text-[12px]">
                      <p className="text-[#000000] font-normal">Balance:</p>
                      <p className="text-[#000000] font-normal">
                        KES{" "}
                        {Number(
                          singleTransaction?.running_balance ||
                            singleTransaction?.balance ||
                            "0.00",
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                  )}
                </div>

                {/* Footer - pushed almost to bottom */}
                <div className="justify-start mx-auto w-[92%] pt-5 pb-5 flex-shrink-0">
                  <p className="text-[6px] sm:text-[8px] text-[#000000] font-[400] break-words">
                    This receipt was generated by Anansi Ltd on behalf of your
                    SACCO. All transactions are processed securely and <br />
                    in accordance with applicable Kenyan financial regulations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionModal;
